// extracted by mini-css-extract-plugin
module.exports = {"item":"item___2j1Z1","title":"title___WL1e4"};